// Vendors
import { useEffect, useRef } from 'react';
// Event Handlers
import { GetStateHandlers } from 'handlers/get-state.handlers';
// Types
import { GetStateHookType, GetStateHookReturnType } from 'hooks/types/get-state.hook.type';

const useAppGetStateHook = (props: GetStateHookType): GetStateHookReturnType => {
  const timeoutRef = useRef<any>(null);
  const isMountedRef = useRef(true);

  const { handleCleanupIntervalsOnUnmount, handleGetOnboardingStateEvent } = GetStateHandlers({
    ...props,
    timeoutRef,
    isMountedRef,
  });

  useEffect(() => {
    return () => {
      handleCleanupIntervalsOnUnmount();
    };
  }, []);

  return { handleGetOnboardingStateEvent };
};

export { useAppGetStateHook };
